export default __webpack_public_path__ + "static/media/step2.c20b0a6b.gif";